var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"uni-badge--x"},[_vm._t("default"),(_vm.text)?_c('v-uni-text',{staticClass:"uni-badge",class:_vm.classNames,style:([_vm.positionStyle, _vm.customStyle, _vm.dotStyle]),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.onClick()
}}},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e()],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }